import { combineReducers } from 'redux';
import exploreReducer from './exploreReducers';

export default combineReducers({
  exploreReducer,
});
